<template>
    <tr class="v-reports-header">
        <th class="v-reports-header__title"> {{ group.title }}</th>
        <th class="v-reports-header__cell"></th>
        <th class="v-reports-header__cell"> {{ $t('reports.table.salesPerson.heading') }}</th>
        <th class="v-reports-header__cell"> {{ $t('reports.table.customer.heading') }}</th>
        <th class="v-reports-header__cell"></th>
        <th class="v-reports-header__cell">Bilmodell</th>
        <th class="v-reports-header__cell">Administrasjon</th>
        <th class="v-reports-header__cell">Installasjon</th>
        <th class="v-reports-header__cell v-reports-header__cell--number"> {{ group.total | toCurrency }}</th>
    </tr>

</template>

<script>

  export default {
    name: "vReportsRow",
    props: {
      group: { type: Object, default: null }
    }
  }
</script>

<style lang="scss">

    .v-reports-header {
        &__title {
            padding-top: 1em;
            border-bottom: 1px solid #F3F3F3;
        }

        &__cell {
            padding-top: 1em;
            font-size: .8em;
            vertical-align: bottom;
            border-bottom: 1px solid #F3F3F3;

            &--number {
                text-align: right;
            }
        }
    }
</style>